import { useI18n } from '../../i18n'
import EditEntryModal from './EditEntryModal'
import DateTimeField from '../ui/DateTimeField'
import QuantityField from '../ui/QuantityField'
import {
   closeWeightEditModal,
   deleteEditedWeightEntry,
   editingWeightTimestampValue,
   editingWeightValue,
   isWeightEditModalOpen,
   saveEditedWeightEntry,
   setEditingWeightInputValue,
   setEditingWeightTimestampInputValue,
   weightEditError,
} from '../../state/weightStore'

/**
 * Renders the weight-entry edit modal (value and timestamp).
 *
 * @returns The modal element.
 */
const WeightEditModal = () => {
   const t = useI18n()

   return (
      <EditEntryModal
         id="weight-edit-modal"
         open={isWeightEditModalOpen()}
         title={t('Edit Weight')}
         error={weightEditError()}
         saveId="weight-edit-save-btn"
         cancelId="weight-edit-cancel-btn"
         onSave={saveEditedWeightEntry}
         onCancel={closeWeightEditModal}
         onDelete={deleteEditedWeightEntry}
         deleteId="weight-edit-delete-btn"
      >
         <QuantityField
            id="weight-edit-value"
            quantity="mass"
            label={unit => t('Weight ({unit})', { unit })}
            value={editingWeightValue()}
            onValueInput={setEditingWeightInputValue}
         />
         <DateTimeField
            id="weight-edit-time"
            label={t('Date and time')}
            value={editingWeightTimestampValue()}
            onValueInput={setEditingWeightTimestampInputValue}
         />
      </EditEntryModal>
   )
}

export default WeightEditModal
